import { type ComponentProps } from 'react'
import { Combobox } from '@base-ui/react/combobox'
import { twMerge } from 'tailwind-merge'
import type { PartProps } from '../../../lib/part-props'

interface ComboboxEmptyProps extends PartProps<ComponentProps<typeof Combobox.Empty>> {
  className?: string
}

function ComboboxEmpty({ className, children, ...props }: ComboboxEmptyProps) {
  return (
    <Combobox.Empty
      className={twMerge('text-foreground-secondary px-[7px] py-1.5 text-sm empty:m-0 empty:p-0', className)}
      {...props}
    >
      {children}
    </Combobox.Empty>
  )
}

export { ComboboxEmpty }
